module.exports = require("./../../_gen/starling/display/Button");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/display/Button.js
// module id = 161
// module chunks = 0